import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Lang } from '@debbie/common/dist/lang/Lang.js';
import { setToken } from './auth/actions.js';
import { select as selectCreditor } from './creditors/actions.js';
import { select as selectExclusiveContent } from './exclusiveContent/actions.js';
import { setDispatch, populateInternal, authToken, selectedCreditorId, selectedOwnerIds, exclusiveContent, currentLang, } from './internal.js';
import { setLang } from './lang/actions.js';
import { select as selectTenantId } from './selectedOwners/actions.js';
import { init } from './socket.js';
import store from './store.js';
export const Provider = (props) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    React.useEffect(() => {
        const loadApp = async () => {
            setDispatch(store.dispatch);
            await populateInternal();
            authToken && authToken.length > 0 && setToken(authToken);
            selectedCreditorId && selectCreditor(selectedCreditorId);
            selectedOwnerIds.length > 0 && selectTenantId(selectedOwnerIds[0]);
            exclusiveContent?.length > 0 && selectExclusiveContent(exclusiveContent);
            setLang(currentLang || Lang.da);
            if (authToken && selectedOwnerIds[0]) {
                init(authToken, selectedOwnerIds[0]);
            }
            setIsLoaded(true);
        };
        loadApp();
    }, []);
    return ((isLoaded && (React.createElement(ReduxProvider, { store: store }, props.children))) || React.createElement(React.Fragment, null));
};
export default Provider;
//# sourceMappingURL=Provider.js.map